import { type ReactElement, useState } from 'react';
import { reviewErrorMessage } from '@/entities/review';
import { Button } from '@/shared/ui';
import { useDeleteReview } from '../model/use-delete-review';
import { DeleteReviewDialog } from './delete-review-dialog';

const DELETE_FALLBACK = '후기를 삭제하지 못했어요. 잠시 후 다시 시도해 주세요.';

interface DeleteReviewButtonProps {
  readonly review: { readonly id: string; readonly productId: string };
}

export const DeleteReviewButton = ({ review }: DeleteReviewButtonProps): ReactElement => {
  const { remove, isPending } = useDeleteReview();
  const [open, setOpen] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const confirm = async (): Promise<void> => {
    setError(null);
    try {
      await remove(review);
      setOpen(false);
    } catch (caught) {
      setError(reviewErrorMessage(caught, DELETE_FALLBACK));
    }
  };

  return (
    <>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        onClick={() => {
          setError(null);
          setOpen(true);
        }}
      >
        삭제
      </Button>
      {open ? (
        <DeleteReviewDialog
          onConfirm={() => void confirm()}
          onClose={() => setOpen(false)}
          pending={isPending}
          message={error}
        />
      ) : null}
    </>
  );
};
